<ippro-datatable class="utilityNetworkAuthorityForMapRequestAuditLogs"
                 @row-clicked="rowClicked" :mod-clickable-rows="modClickableRows" mod-zebra
                 mod-hide-pagination :meta="meta"
                 :dataset="responderAuditLog" :columns="columns"
                 :fetching="responderAuditLogsTableLoading">
    <template v-slot:noresults>
        <div v-vl-align:center>
            <vl-u-spacer mod-large/>
            <p>Er zijn nog geen zones toegevoegd voor deze planaanvraag.</p>
        </div>
    </template>
    <template v-slot:actions v-if="hasResponders">
        <div v-vl-align:left v-if="!toggleRemovedKlimClicked">
            <img src="/img/logo-klim.svg" class="klim-pictogram" alt="Toon alle KLIM-KLB's"/>&nbsp;
            <vl-button :mod-disabled="toggleRemovedKlimClicked" mod-link @click="toggleRemovedKlim">
                Toon alle KLIM-KLB’s
            </vl-button>
        </div>
    </template>
</ippro-datatable>